import React from "react";

const STATUS_LABELS = {
    INACTIVE: "INACTIVE",
    NO_SUBSCRIPTION: "NO SUBSCRIPTION",
    EXPIRED: "EXPIRED",
    ZERO_TARGET: "ZERO TARGET"
};

const CandidateRow = ({ candidate }) => {
    const ignored = !candidate.counted;

    return (
        <div className={`candidate-row ${ignored ? "ignored" : ""}`}>
            {/* Empty arrow column */}
            <div />

            {/* Name */}
            <div className="col name">
                {candidate.candidateName}
            </div>




            {/* Status */}
            <div className="col status">
                {ignored ? (
                    <span className="status-badge ignored">
                        {STATUS_LABELS[candidate.ignoreReason] || "IGNORED"}
                    </span>
                ) : (
                    <span className="status-badge active">COUNTED</span>
                )}
            </div>
            {/* Numbers */}
            <div className="col numbers">
                {candidate.applied} / {candidate.target}
            </div>
            {/* Empty "Candidates" column */}
            <div />

        </div>

    );
};

export default CandidateRow;
